import { Badge } from "@/components/ui/badge";
import type {
  ActivationKeyStatus,
  CellStatus,
  CustomerStatus,
  DeploymentStatus,
  LicenseStatus,
  ReleaseChannel,
  SpecPhase,
} from "@/types";

// #343 Provisionierung
export function CellStatusBadge({ status }: { status: CellStatus }) {
  return <Badge variant={status === "enrolled" ? "enrolled" : "busy"}>{status}</Badge>;
}

export function SpecPhaseBadge({ phase, removed }: { phase: SpecPhase | null | undefined; removed?: boolean }) {
  if (removed && phase !== "removed") return <Badge variant="orphaned">entfernen…</Badge>;
  if (!phase) return <Badge variant="outline">kein Status</Badge>;
  const variant = phase === "ready" ? "active" : phase === "failed" ? "revoked" : phase === "removed" ? "offline" : "busy";
  return <Badge variant={variant}>{phase}</Badge>;
}

export function ReleaseChannelBadge({ channel }: { channel: ReleaseChannel }) {
  return <Badge variant={channel === "stable" ? "active" : "busy"}>{channel}</Badge>;
}

// Status → Badge-Variante. Eine Quelle fuer die Farbzuordnung im Portal.
export function LicenseStatusBadge({ status }: { status: LicenseStatus }) {
  const variant = status === "active" ? "active" : status === "suspended" ? "busy" : "revoked";
  return <Badge variant={variant}>{status}</Badge>;
}

export function CustomerStatusBadge({ status }: { status: CustomerStatus }) {
  return <Badge variant={status === "active" ? "active" : "busy"}>{status}</Badge>;
}

export function ActivationKeyStatusBadge({ status }: { status: ActivationKeyStatus }) {
  const variant = status === "open" ? "available" : status === "consumed" ? "enrolled" : "offline";
  return <Badge variant={variant}>{status}</Badge>;
}

export function DeploymentStatusBadge({ status }: { status: DeploymentStatus }) {
  return <Badge variant={status === "active" ? "active" : "offline"}>{status}</Badge>;
}

export function TrialBadge() {
  return <Badge variant="outline">trial</Badge>;
}
